export default "__VITE_ASSET__CIaN08tn__"